import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import CreatePurchaseOrder from '../../../pages/Inbound/Purchase-Order/Create-Purchase-Order/CreatePurchaseOrder';
import EditPurchaseOrder from "../../../pages/Inbound/Purchase-Order/Edit-Purchase-Order/EditPurchaseOrder";
import CreatePurchaseReceipt from '../../../pages/Inbound/GRN/Create-Purchase-Receipt/CreatePurchaseReceipt';
import GRN from '../../../pages/Inbound/GRN/Main/GRN';
import Createputaway from '../../../pages/Inbound/Put-away/Main/Putaway'
import Purchaseorder from "../../../pages/Inbound/Purchase-Order/Main/Purchase-order";
import CreatePutAway from "../../../pages/Inbound/Put-away/Put-Away-Creation/CreatePutAway";
import ViewPutAway from "../../../pages/Inbound/Put-away/Put-Away-view/ViewPutAway";
import GateEntryList from "../../../pages/Inbound/Gate-Entry/Main/GateEntryList";
import CreateGateEntry from "../../../pages/Inbound/Gate-Entry/Create-Gate-Entry/CreateGateEntry";
import Viewpurchase from "../../../pages/Inbound/Purchase-Order/View-Purchase-Order/Viewpurchaseorder";
import EditPurchaseRecipt from "../../../pages/Inbound/GRN/Edit-Purchase-Reciept/EditPurchaseRecipt";
import ViewpurchaseReciept from "../../../pages/Inbound/GRN/View-Purchase- Reciept/ViewpurchaseReciept"
import ViewGateEntry from "../../../pages/Inbound/Gate-Entry/View-Gate-Entry/ViewGateEntry";
import EditPutAway from "../../../pages/Inbound/Put-away/Put-Away-Edit/EditPutAway";
import EditGateEntry from "../../../pages/Inbound/Gate-Entry/Edit-Gate-Entry/EditGateEntry";
import DuplicatePurchaseOrder from "../../../pages/Inbound/Purchase-Order/Duplicate-PO/DuplicatePurchaseOrder";
import AsnList from "../../../pages/Inbound/AdvanceShipmentNote/AsnList";
import AsnCreate from "../../../pages/Inbound/AdvanceShipmentNote/createshipment/AsnCreate";
import AsnView from "../../../pages/Inbound/AdvanceShipmentNote/viewshipment/AsnView";
import AsnEdit from "../../../pages/Inbound/AdvanceShipmentNote/editshipment/AsnEdit";
import Dashboard from "../../../pages/Inbound/Dashboard/Dashboard";


function InboundRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/gate-entry/gate-entry-list" element={<GateEntryList />} />
                <Route path="/gate-entry/create-gate-entry" element={<CreateGateEntry />} />
                <Route path="/gate-entry/view-gate-entry" element={<ViewGateEntry />} />
                <Route path="/gate-entry/edit-gate-entry" element={<EditGateEntry />} />
                <Route path="/purchaseorder/purchase-orders" element={<Purchaseorder />} />
                <Route path="/purchaseorder/create-purchase-order" element={<CreatePurchaseOrder />} />
                <Route path="/purchaseorder/edit-purchase-order" element={<EditPurchaseOrder />} />
                <Route path="/purchaseorder/duplicate-purchase-order" element={<DuplicatePurchaseOrder />} />
                <Route path="/purchaseorder/view-purchase-order" element={<Viewpurchase />} />
                <Route path="/grn/create-purchase-receipt" element={<CreatePurchaseReceipt />} />
                <Route path="/grn/edit-purchase-receipt" element={<EditPurchaseRecipt />} />
                <Route path="/grn/view-purchase-receipt" element={<ViewpurchaseReciept />} />
                <Route path="/grn/create-grn-receipt" element={<GRN />} />
                <Route path="/putaway/create-putaway" element={<CreatePutAway />} />
                <Route path="/putaway/view-putaway" element={<ViewPutAway />} />
                <Route path="/putaway/create-in-putaway" element={<Createputaway />} />
                <Route path="/asn/inboundasn" element={<AsnList />} />
                <Route path="/asn/createasn" element={<AsnCreate />} />
                <Route path="/asn/view" element={<AsnView />} />
                <Route path="/asn/edit" element={<AsnEdit />} />
                <Route path="/putaway/edit-putaway" element={<EditPutAway />} />
            </Route>
        </Routes>
    );
}

export default InboundRoute;
